import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import api from '../lib/api.js';
import { useEntityScope } from './useEntityScope.js';

const HYPOTHESIS_KEY = ['revenue-hypothesis'];

/**
 * Query — hypothèse de revenus active (ou null si pas configurée).
 * Désactivée en vue groupe (l'hypothèse est par entité).
 */
export function useRevenueHypothesis() {
  const { isGroup } = useEntityScope();
  return useQuery({
    queryKey: HYPOTHESIS_KEY,
    queryFn: async () => {
      const data = await api.get('/revenue-hypothesis');
      return data?.hypothesis ?? null;
    },
    staleTime: 60_000,
    enabled: !isGroup,
  });
}

/**
 * Mutation — POST /revenue-hypothesis/calibrate?year=YYYY
 * N'écrit pas en DB : retourne uniquement le calcul auto.
 * Retourne : { baseline_cents_monthly, seasonality_coefs, total_year_cents, source_tx_count, year }
 */
export function useCalibrateHypothesis() {
  return useMutation({
    mutationFn: ({ year = 2025 } = {}) =>
      api.post(`/revenue-hypothesis/calibrate?year=${year}`),
  });
}

/**
 * Mutation — POST (create) ou PATCH si id présent.
 * Invalide hypothesis + cash-flow + forecasts.
 */
export function useUpsertHypothesis() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body) => {
      if (body.id) {
        const { id, ...patch } = body;
        return api.patch(`/revenue-hypothesis/${id}`, patch);
      }
      return api.post('/revenue-hypothesis', body);
    },
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: HYPOTHESIS_KEY });
      qc.invalidateQueries({ queryKey: ['cash-flow'] });
      qc.invalidateQueries({ queryKey: ['forecasts'] });
    },
  });
}
